import { InlineBanner, IconCircleXMark } from '@7shifts/sous-chef-base';
import { LocationInfo } from './LocationInfo/LocationInfo';
import { useTranslation } from '@src/i18n';
import './OfflineLockoutScreen.css';

/**
 * Full-screen lockout shown once the offline time limit has been exceeded
 * (API-4380 / API-4643). No punch pad is available — the company logo,
 * location, clock and date stay centered with a red error banner. The terminal
 * auto-returns to the normal punch pad on reconnection (driven by the network
 * status that gates this screen).
 */
export function OfflineLockoutScreen() {
    const { t } = useTranslation();

    return (
        <div className="offline-lockout" data-testid="offline-lockout">
            <LocationInfo>
                <div className="offline-lockout__banner">
                    <InlineBanner
                        theme="danger"
                        icon={<IconCircleXMark variant="solid" />}
                        title={t('offline.lockout.heading')}
                        testId="offline-lockout-banner"
                    >
                        {t('offline.lockout.body')}
                    </InlineBanner>
                </div>
            </LocationInfo>
        </div>
    );
}
